import { T_RESPONSE, LLMProvider } from "../types";

/**
 * Response type for report comp request
 */
export interface ReportCompResponse extends T_RESPONSE {
	id?: string;
	wsId?: string;
}

/**
 * Default models for REPORT_COMP flow
 * Using faster/cheaper models since report generation is a structured task
 */
export const DEFAULT_REPORT_COMP_MODELS: Record<LLMProvider, string> = {
	anthropic: 'anthropic/claude-haiku-4-5-20251001',
	gemini: 'gemini/gemini-3-flash-preview',
	openai: 'openai/gpt-4o-mini',
	groq: 'groq/llama-3.3-70b-versatile'
};
